<template>
	<div class="order-search-body">
		<div class="filters-box-row">
			<!-- <div class="filters-container">
				<div class="input-box">
					<el-date-picker
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						:default-time="['00:00:00', '23:59:59']"
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</div>
			</div> -->
			<div class="filters-container">
				<div class="input-box">
					<!-- <el-input
						class="search-input"
						v-model="staff"
						placeholder="请输入员工姓名"
						size="small"
						clearable
						prefix-icon="el-icon-search"
						@keyup.enter.native="search">
					</el-input> -->
					<el-select
						v-model="staff"
						size="small"
						filterable
						multiple
						collapse-tags
						style="margin-left: 20px;"
						placeholder="请选择员工">
						<el-option
							v-for="item in options"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container" style="position:relative">
				<el-button size="small" type="primary" class="btn fx-btn" style="margin-left: 10px" @click="search">查询</el-button>
				<el-button size="small" class="btn fx-btn" plain style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
			<div class="filters-container" style="position:relative">
				最近统计更新时间：{{updateTime}} 00:00
			</div>
			<div style="position: absolute;right: 20px;display: flex;flex-direction: row;width: 190px;align-items: center;">
				<div class="batch-register-btn"  @click="listExport" >
					<i class="excel-icon import-excel-icon"/>
					<span>导出</span>
				</div>
				<el-tooltip effect="dark" placement="left" popper-class="tip-class">
					<div slot="content">
						统计时间：当日00：00前生成的返佣提现数据。<br/><br/>
						统计数据：已完成订单没有待处理的退单，且不可申请退货和修改实收数。每日00:00生成前一天数据。<br/><br/>
						到账周期：提现申请审批同意后，T+n 由财务线下银行转账且不限于银行转账的方式进行提现结算。
					</div>
					<div class="tip-icon">
						<img src="~/images/icon/tooltip-icon.png" width="14" height="14">统计规则
					</div>
				</el-tooltip>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		orderBy: {
			type: String,
			default: ''
		},
		orderKey: {
			type: String,
			default: ''
		},
		ids: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		},
		options: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			staff: [],
			// dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			params: {
				// dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			},
			updateTime: ''
		}
	},
	created () {
		this.getYesday()
	},
	methods: {
		listExport () {
			let params = this.params
			params.orderKey = this.orderKey
			params.orderBy = this.orderBy
			params.staffIds = this.staff
			// if (this.params.dateValue.length > 0) {
			// 	params.beginDate = this.params.dateValue[0]
			// 	params.endDate = this.params.dateValue[1]
			// }
			delete params.staff
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/commission/returnsum/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(params))
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			let name = ''
			// if (this.params.dateValue.length > 0) {
			// 	name = this.params.dateValue[0] + '-' + this.params.dateValue[1] + '提成统计结果.xls'
			// } else {
			name = '提成统计结果.xls'
			// }
			name = name.replace(/:/g, '：')
			a.download = name
			a.href = blobUrl
			a.click()
		},
		search () {
			this.params = {
				staff: this.staff
				// dateValue: this.dateValue
			}
			// if (this.params.dateValue === null) {
			// 	this.params.dateValue = []
			// }
			this.$emit('handleSearch', {
				staff: this.params.staff
				// dateValue: this.params.dateValue
			})
		},
		clear () {
			this.staff = []
			this.$emit('handleSearch', {
				staff: []
			})
		},
		getYesday () {
			let time = new Date().getTime()
			let today = new Date(time)
			this.updateTime = today.getFullYear() + '.' + (today.getMonth() > 9 ? (today.getMonth() + 1) : '0' + (today.getMonth() + 1)) + '.' + (today.getDate() > 9 ? (today.getDate()) : '0' + (today.getDate()))
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	padding: 10px 0;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box;
	position :relative;
	text-align: left
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 200px
		}
	}
	.tip-icon {
		display: flex;
		align-items: center;
		img {
			cursor: pointer;
			margin-right: 5px
		}
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 10px;
		display: flex;
		width: 100px;
		height: 32px;
		justify-content center;
		align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
}
</style>
<style lang="stylus">
.el-tooltip__popper.is-dark.tip-class {
	width: 320px
}
</style>
